<template>
<header class="navbar" :class="{scrolled, open: menuOpen}">
 <div class="container nav-inner">
  <router-link to="/" class="brand" @click="closeMenu">
 <span class="brand-mark">N</span>
 <span>
 <strong>NWOKOMA</strong>
 <small>ASSOCIATES</small>
 </span> 
 </router-link>
  <nav class="desktop-nav">
 <router-link v-for="item in links" :key="item.to" :to="item.to">{{ item.label }}</router-link>
 <router-link to="/properties" class="nav-cta">Find a Property <span>↗</span>
 </router-link>
 </nav>
  <button class="menu-btn" aria-label="Toggle menu" :aria-expanded="menuOpen" @click="toggleMenu">
 <span>
 </span>
 <span>
 </span>
 </button>
 </div>
 <transition name="slide">
 <div v-if="menuOpen" class="mobile-nav">
 <router-link v-for="item in links" :key="item.to" :to="item.to" @click="closeMenu">{{item.label}}</router-link>
 <router-link to="/properties" class="mobile-cta" @click="closeMenu">Find a Property ↗</router-link>
 </div>
 </transition>
</header>
</template>
<script>
export default { name:'Navbar', data(){return{scrolled:false,menuOpen:false,links:[{label:'Home',to:'/'},{label:'Properties',to:'/properties'},{label:'Services',to:'/services'},{label:'Projects',to:'/projects'},{label:'About',to:'/about'},{label:'Blog',to:'/blog'},{label:'Contact',to:'/contact'}]}}, mounted(){window.addEventListener('scroll',this.handleScroll,{passive:true})}, beforeUnmount(){window.removeEventListener('scroll',this.handleScroll)}, methods:{handleScroll(){this.scrolled=window.scrollY>24},toggleMenu(){this.menuOpen=!this.menuOpen},closeMenu(){this.menuOpen=false}} }
</script>
